import React from 'react';
import PropTypes from 'prop-types';
import MohwPrsReport from './MohwPrsReport';

export default function MohwPrsReportDays({ clientOptions = [] }) {
  return <MohwPrsReport clientOptions={clientOptions} dayMode={true} />;
}

MohwPrsReportDays.propTypes = {
  clientOptions: PropTypes.array,
};
